import { BuyerApi } from '../../apis/BuyerApi';
import { BuyerInfoDTO } from '../../models/Buyer';
import { PersonalProfileDTO } from './PersonalType';

const plainPhone = (phone?: string): string | undefined => {
  if (!phone) return phone;
  if (phone.startsWith('+86') && phone.length === 14) {
    return phone.substring(3);
  }
  if (phone.startsWith('86') && phone.length === 13) {
    return phone.substring(2);
  }
  return phone;
};

export const genderLabel = (gender?: string): string => {
  switch (gender) {
    case 'male':
      return '男';
    case 'female':
      return '女';
    case 'secret':
      return '保密';
    default:
      return gender?.trim() ? gender : '未设置';
  }
};

const fromBuyerInfo = (buyer: BuyerInfoDTO): PersonalProfileDTO => ({
  nickname: buyer.nickname?.trim() || undefined,
  phone: plainPhone(buyer.phone),
  gender: genderLabel(buyer.gender),
  avatarUrl: buyer.avatarUrl?.trim() || undefined,
  isCompany: buyer.isCompany,
  company: buyer.company?.trim() || undefined,
});

const fetchProfile = async (): Promise<PersonalProfileDTO | null> => {
  const buyer = await BuyerApi.getBuyerByToken();
  if (!buyer) return null;
  return fromBuyerInfo(buyer);
};

export const PersonalApi = {
  fetchProfile,
  genderLabel,
};
